import {useCallback, useRef} from 'react';

import getResult from 'topmeteo/utils/fetch';

import {Parser, URL, getBody} from './utils';

import BeaconTransmitter from './Transmitter';

const NoopTransmitter = ({children}) => children;

const Transmitter = navigator.sendBeacon ? BeaconTransmitter : NoopTransmitter;

const send = async data => {
    const {status} = await getResult(URL, {
        credentials: 'same-origin',
        method: 'post',
        body: getBody(data),
    });

    return status;
};

const Tracker = ({onLoad, children}) => {
    const dataRef = useRef([]);
    const timerRef = useRef(0);

    const handleLoad = useCallback(
        event => {
            onLoad(event);

            Parser.href = event.target.src;

            const {pathname, search} = Parser;

            dataRef.current.push(pathname + search);

            if (timerRef.current) clearTimeout(timerRef.current);

            const sendData = () => {
                const data = [...dataRef.current];

                /* empty the queue */
                dataRef.current = [];

                (async () => {
                    const result = await send(data);

                    if (result === 204) return true;

                    /* we dont retry invalid data or server errors */
                    if (result >= 400 && result <= 500) return false;

                    /* sending failed, requeue unsent data */
                    dataRef.current = [...data, ...dataRef.current];

                    return false;
                })();
            };

            /* Try to keep the array small. Send immediately when
               more than 24 images are enqueued. */
            const delay = dataRef.current.length > 24 ? 0 : 1000;

            timerRef.current = setTimeout(sendData, delay);
        },
        [onLoad],
    );

    return (
        <Transmitter dataRef={dataRef} timerRef={timerRef}>
            {children(handleLoad)}
        </Transmitter>
    );
};

export default Tracker;
